jQuery(document).ready(function($) {
    const cartPopup = $('#cart-popup');
    const backplate = $('.backplate');

    function initializeCart() {
        if ($('#cart-button').length && $('#cart-count').length && !ajax_object.is_cart) {
            bindEvents();
            // refreshCart();
        }
    }

    function bindEvents() {
        $(document).on('click', '#apply-coupon', applyCoupon);
        $(document).on('click', '#cart-button', openCart);
        $(document).on('click', '#close-cart-popup, .backplate', closeCart);
        $(document).on('click', '.quantity-decrease, .quantity-increase', handleQuantityChange);
        $(document).on('input', '.quantity-input', handleQuantityInput);
        $(document).on('click', '.cart-popup .woocommerce-remove-coupon', handleCouponRemoval);
        $(document).on('click', '.custom-cart-item-remove', handleRemoveItem);
        $(document).on('change', 'select.shipping_method, input[name^="shipping_method"]', handleShippingMethodChange);
        $(document).on('click', '#cart-popup .shipping-calculator-btn', toggleShippingCalculator);
        $(document).on('click', '#cart-popup button[name="calc_shipping"]', handleCalcShipping);

        $(document).on('click', '#cart-popup__backplate', toggleShippingCalculator);

        $(document.body).on('added_to_cart', handleAddedToCart);
    }

    function handleAddedToCart(event, fragments, cart_hash, $button) {
        handleCartRefresh({fragments})
        openCart()
    }

    function getCouponMessage() {
        return $('#coupon-message');
    }

    function toggleShippingCalculator(e) {
        if (e) {
            e.preventDefault();
        }

        $('#cart-shipping-calculator').toggleClass('active');
        $('#cart-popup__backplate').toggleClass('active');
    }

    function openCart(e) {
        if (e) {
            e.preventDefault();
        }
        cartPopup.addClass('active');
        backplate.addClass('backplate--open');
    }

    function closeCart() {
        cartPopup.removeClass('active');
        backplate.removeClass('backplate--open');

        clearCouponMessage();
    }

    function clearCouponMessage() {
        setTimeout(() => {
            getCouponMessage().html('');
        }, 500);
    }

    function refreshCart() {
        cartPopup.addClass('loading');
        $.get('/?wc-ajax=get_refreshed_fragments', (data) => handleCartRefresh(data?.data || data))
    }

    function handleCartRefresh(data) {
       
        if (data && data.fragments) {
            $.each(data.fragments, function(selector, content) {
                $(selector).replaceWith(content);
            });
        }
    }

    function handleQuantityChange(e) {
        e.preventDefault();
        e.stopPropagation();
        const $button = $(this);
        const $input = $button.siblings('.quantity-input');
        let quantity = parseInt($input.val());

        if ($button.hasClass('quantity-decrease')) {
            quantity = Math.max(1, quantity - 1);
        } else {
            quantity++;
        }

        $input.val(quantity).trigger('input');
    }

    function handleQuantityInput() {
        const $input = $(this);
        let quantity = parseInt($input.val());
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
            $input.val(quantity);
        }
        debouncedUpdateCartItemQuantity($input);
    }

    const debouncedUpdateCartItemQuantity = debounce(function($input) {
        const $item = $input.closest('.custom-cart-item');
        const cartItemKey = $item.data('cart-item-key');
        const quantity = parseInt($input.val());
        updateCartItemQuantity(cartItemKey, quantity, $item);
    }, 500);

    function updateCartItemQuantity(cartItemKey, quantity, $item) {
        disableQuantityControls($item);
        cartPopup.addClass('loading');
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'update_cart_item_quantity',
                cart_item_key: cartItemKey,
                quantity: quantity,
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    cartPopup.removeClass('loading');
                    $('.custom-cart-item').each(function() {
                        enableQuantityControls($(this));
                    });

                    handleCartRefresh(response.data);
                } else {
                    console.error('Errore nell\'aggiornamento della quantità:', response.data.message);
                    enableQuantityControls($item);
                }
            },
            error: function(xhr, status, error) {
                console.error('Errore AJAX:', status, error);
                enableQuantityControls($item);
            }
        });
    }

    function disableQuantityControls($item) {
        $item.find('.quantity-decrease, .quantity-increase, .quantity-input').prop('disabled', true);
    }

    function enableQuantityControls($item) {
        $item.find('.quantity-decrease, .quantity-increase, .quantity-input').prop('disabled', false);
    }

    function applyCoupon() {
        const couponCode = document.getElementById('coupon-code').value;
        const $applyButton = $('#apply-coupon');
        const $couponInput = $('#coupon-code');

        $applyButton.prop('disabled', true).addClass('loading');
        $couponInput.prop('disabled', true);
        cartPopup.addClass('loading');

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'apply_coupon',
                coupon_code: couponCode,
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    handleCartRefresh(response.data);
                    getCouponMessage().html(response?.data?.message).css('color', 'green');
                    $('#coupon-code').val('');
                } else {
                    getCouponMessage().html(response?.data?.message).css('color', 'red');
                }
            },
            error: function() {
                getCouponMessage().html(response?.data?.message).css('color', 'red');
            },
            complete: function() {
                $applyButton.prop('disabled', false).removeClass('loading');
                $couponInput.prop('disabled', false);
                cartPopup.removeClass('loading');
            }
        });
    }

    function handleCouponRemoval(e) {
        e.preventDefault();
        const couponCode = $(this).data('coupon');
        const $removeButton = $(this);
        
        $removeButton.prop('disabled', true).addClass('loading');
        removeCoupon(couponCode, $removeButton);
    }

    function removeCoupon(couponCode, $removeButton) {
        cartPopup.addClass('loading');
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'remove_coupon',
                coupon_code: couponCode,
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    handleCartRefresh(response.data);
                    getCouponMessage().html(response?.data?.message).css('color', 'green');
                } else {
                    getCouponMessage().html(response?.data?.message).css('color', 'red');
                }
            },
            error: function() {
                getCouponMessage().html(response?.data?.message).css('color', 'red');
            },
            complete: function() {
                $removeButton.prop('disabled', false).removeClass('loading');
                cartPopup.removeClass('loading');
            }
        });
    }

    function handleRemoveItem(e) {
        e.preventDefault();
        const $item = $(this).closest('.custom-cart-item');
        const cartItemKey = $item.data('cart-item-key');
        removeCartItem(cartItemKey);
    }

    function removeCartItem(cartItemKey) {
        cartPopup.addClass('loading');
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'remove_cart_item',
                cart_item_key: cartItemKey,
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    handleCartRefresh(response.data);
                } else {
                    console.error('Errore nella rimozione dell\'item:', response.data.message);
                }
            },
            error: function(xhr, status, error) {
                console.error('Errore AJAX:', status, error);
            }
        });
    }

    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    function handleShippingMethodChange() {
        const shippingMethod = $('select.shipping_method, input[name^="shipping_method"]:checked, input[name^="shipping_method"][type="hidden"]').val();
        cartPopup.addClass('loading');
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'update_shipping_method',
                shipping_method: [shippingMethod],
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    handleCartRefresh(response.data);
                } else {
                    console.error('Errore nell\'aggiornamento del metodo di spedizione:', response.data.message);
                }

                cartPopup.removeClass('loading');

            },
            error: function(xhr, status, error) {
                console.error('Errore AJAX:', status, error);
                cartPopup.removeClass('loading');
            }
        });
    }

    function handleCalcShipping(e) {
        e.preventDefault();
        cartPopup.addClass('loading');
        const $form = $(this).closest('form');
        let formData = {};
        $form.serializeArray().forEach(function(item) {
            formData[item.name] = item.value;
        });

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                ...formData,
                action: 'update_shipping_data',
                security: ajax_object.nonce
            },
            success: function(response) {
                if (response.success) {
                    handleCartRefresh({
                        'fragments': {
                            '.cart_totals': $(response.data?.fragments?.['#cart-totals']).find('.cart_totals')
                        }
                    });

                    toggleShippingCalculator();
                } else {
                    console.error('Errore nell\'aggiornamento dei dati di spedizione:', response.data.message);
                }
            },
            error: function(xhr, status, error) {
                console.error('Errore AJAX:', status, error);
            }
        });
    }

    initializeCart();
});
